import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue"
import AppPage from "@/components/layout/AppPage.vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import UserAvatarGroup from "@/components/widgets/common/UserAvatarGroup.vue"
import { useAuth } from "@/store/auth/useAuth"
import NewProjectWizard from "@/modules/Missions/CreateNewProject/NewProjectWizard.vue"
import ServiceAgreementTemplate from "@/components/templates/ServiceAgreementTemplate.vue"
import { UpdateSessionPayload } from "@/store/auth"
import Printable from "@/components/layout/Printable.vue"
import { useNotification } from "@/hooks/useNotification"
import useRouter from "@/router/useRouter"
import { useMutation } from "@/hooks/useMutation"
import {
  MissionLifecycle,
  ClientMissionLifecyclesListQuery,
  AcceptServiceAgreementMutation,
  AcceptServiceAgreementMutationMutation,
} from "@/gql"
import { PageState } from "@/constants"
import { usePageState } from "@/hooks/usePageState"
import { useTranslation } from "@/i18n/useTranslation"


export default /*#__PURE__*/_defineComponent({
  __name: 'Projects',
  setup(__props) {

const query = ClientMissionLifecyclesListQuery
const showNewProjectWizard = ref(false)
const { updateSession, user } = useAuth()
const client = user?.clientsAsAdmin?.[0]
const showServiceAgreement = ref(false)
const { addSuccess } = useNotification()
const { mutate } = useMutation()
const { t } = useTranslation("Client/Projects")

const pageState = ref(PageState.Idle)

const { router, routes } = useRouter()
const { handlePageState } = usePageState(pageState)

const headers = [
  {
    text: "Project",
    value: "name",
    custom: true,
    width: "30%",
  },
  {
    text: "Progress",
    value: "missionScope",
    custom: true,
    sortable: false,
  },
  {
    text: "Stage",
    value: "state",
    custom: true,
    sortable: false,
  },
  {
    text: "Team",
    value: "collaborators",
    custom: true,
    sortable: false,
  },
  {
    text: "Service",
    value: "scopeService",
    custom: true,
    sortable: false,
  },
]

const listFilters = [
  {
    field: "state",
    label: "Stage",
    filters: {
      lead_stage: "Lead",
      scoping_stage: "Scoping",
      proposal_stage: "Proposal",
      contracting_stage: "Contracting",
      staffing_stage: "Staffing",
      execution_stage: "Execution",
      completed: "Completed",
      archived: "Archived",
      paused: "Paused",
    },
  },
]

const searchFilters = [
  {
    field: "name",
    label: "missions",
    expanded: true,
  },
]

const dateFilters = [
  {
    field: "createdAtDate",
    label: "Date",
  },
]

const getStateColor = (state: string) => {
  let color = ""
  switch (state) {
    case "lead_stage":
    case "scoping_stage":
      color = "brown lighten-5 brown--text text--darken-3"
      break
    case "contracting_stage":
    case "proposal_stage":
      color = "yellow lighten-5 yellow--text text--darken-3"
      break
    case "staffing_stage":
      color = "lime lighten-5 lime--text text--darken-3"
      break
    case "execution_stage":
      color = "light-green lighten-5 light-green--text text--darken-3"
      break
    case "completed":
      color = "teal lighten-5 teal--text text--darken-3"
      break
    default:
      color = "grey lighten-2"
      break
  }
  return color
}

const gotoDetailPage = (mission: MissionLifecycle) => {
  router.push({
    name: routes.ClientProjectDetails,
    params: { id: mission.id.toString() },
  })
}

const onOpenNewProjectDialog = () => {
  showNewProjectWizard.value = true
}

const onCloseDialog = () => {
  showNewProjectWizard.value = false
}

const resetSession = () => {
  if (user?.clientsAsAdmin?.length) {
    user.clientsAsAdmin[0].acceptedServiceAgreement = true
    updateSession(user as unknown as UpdateSessionPayload)
  }
}

const onServiceTermsAccepted = async () => {
  const result = await mutate<AcceptServiceAgreementMutationMutation>({
    mutation: AcceptServiceAgreementMutation,
    done: () => {
      resetSession()
      showServiceAgreement.value = false
    },
  })

  if (!result?.data?.acceptServiceAgreement.error) {
    addSuccess("Service agreement accepted")
  }
}

const acceptedServiceAgreement = computed(() => client?.acceptedServiceAgreement)

const noDataCallback = () => {
  handlePageState(PageState.Empty)
}

return { __sfc: true,query, showNewProjectWizard, updateSession, user, client, showServiceAgreement, addSuccess, mutate, t, pageState, router, routes, handlePageState, headers, listFilters, searchFilters, dateFilters, getStateColor, gotoDetailPage, onOpenNewProjectDialog, onCloseDialog, resetSession, onServiceTermsAccepted, acceptedServiceAgreement, noDataCallback, AppPage, Icon, UserAvatarGroup, NewProjectWizard, ServiceAgreementTemplate, Printable, PageState }
}

})